import React, { FC, Suspense, lazy } from "react";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";
import {
  ProductCarouselConfig,
  useAnalytics,
  Product,
} from "@commons-monorepo/index";

const ProductsSliderSkin1 = lazy(() => import("./skins/product-slider-skin-1/products-slider-skin-1"));
const ProductsSliderSkin2 = lazy(() => import("./skins/product-slider-skin-2/products-slider-skin-2"));

const ProductsSlider: FC<WidgetProps<Product[], ProductCarouselConfig>> = ({
  id,
  data: products,
  config,
  type,
  theme,
  localConfig,
  storeMetadata,
}) => {
  const [logEvent] = useAnalytics({ storeMetadata });
  const logClick = () => {
    logEvent("select_button", {
      user_type: "buyer",
      platform: "web",
      option: (config as ProductCarouselConfig).filter_type,
      event_subtype: "carousel_view_all",
      carousel_id: type === WidgetType.PRODUCT_CAROUSEL_1 ? "1" : "2",
    });
  };

  return (
    <div id={id}>
      <Suspense>
        {type === WidgetType.PRODUCT_CAROUSEL_1 && (
          <ProductsSliderSkin1
            id={id!}
            key={id!}
            products={products as Product[]}
            config={config as ProductCarouselConfig}
            log={logClick}
            theme={theme}
            localConfig={localConfig}
            storeMetadata={storeMetadata}
          />
        )}
        {type === WidgetType.PRODUCT_CAROUSEL_2 && (
          <ProductsSliderSkin2
            id={id!}
            key={id!}
            products={products as Product[]}
            config={config as ProductCarouselConfig}
            log={logClick}
            theme={theme}
            localConfig={localConfig}
            storeMetadata={storeMetadata}
          />
        )}
      </Suspense>
    </div>
  );
};

export default ProductsSlider;
